export default __webpack_public_path__ + "static/media/ColdCuts.d98c98f0.jpg";